enum QuoteErrorType {
    Engine = "Engine",
    Validation = "Validation",
    MinimumPremium = "MinimumPremium",
    Other = "Other"
}

export default QuoteErrorType;
